export default "__VITE_ASSET__olBW3aaB__"